var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.013,
    height: 19.485,
    viewBox: "0 0 17.013 19.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7068",
    "data-name": "Group 7068",
    transform: "translate(-58.493 -430.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7471",
    "data-name": "Path 7471",
    d: "M85,316a3,3,0,1,0,.879-2.121A3,3,0,0,0,85,316Z",
    transform: "translate(-21 123)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7472",
    "data-name": "Path 7472",
    d: "M93.657,321.657,89.414,325.9a2,2,0,0,1-2.827,0l-4.244-4.243a8,8,0,1,1,11.314,0Z",
    transform: "translate(-21 123)",
    fill: "none",
    stroke: "#0A1E5B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressesMenu);
export default __webpack_public_path__ + "static/media/addresses-menu.a83631d469bcc40c55b728ce3aa5fe38.svg";
export { ForwardRef as ReactComponent };